var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppshop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 322.673,
    height: 39.378,
    viewBox: "0 0 322.673 39.378",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "appshop",
    transform: "translate(-1407.87 -2154.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4",
    "data-name": "Groupe 4",
    transform: "translate(1407.87 2154.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3",
    "data-name": "Groupe 3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 1.507,
    height: 33.45,
    transform: "translate(80.495 4.458)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_577",
    transform: "translate(0 0.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_474",
    transform: "translate(0.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1192",
    d: "M53.083,1.4H46.641l-.14.42-.56,2.8-.14.42-.28,1.541V7l-.28.84L45.1,8.4h4.621A3.608,3.608,0,0,0,52.8,5.881h0L53.22,4.2V3.92l.42-1.961.14-.56Z",
    transform: "translate(15.679 -1.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1193",
    d: "M48.8,7.3H46.98L41.1,35.169h1.961a5.22,5.22,0,0,0,4.9-4.062L53,7.3Z",
    transform: "translate(14.077 0.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1194",
    d: "M21.026,30.629l7.142-15.265-4.2,19.886H29.71l4.9-22.967A4.526,4.526,0,0,0,34.05,8.5a4.03,4.03,0,0,0-3.5-1.4,6.818,6.818,0,0,0-1.681.14,5.648,5.648,0,0,0-4.2,3.5L17.385,25.728l-.14-14.985a3.348,3.348,0,0,0-2.8-3.5A5.744,5.744,0,0,0,12.9,7.1,6.777,6.777,0,0,0,8.842,8.5,7.047,7.047,0,0,0,6.6,12.284L1.7,35.251H7.442l4.2-19.886.56,14.844.14,1.961c0,.42.14.98.14,1.4a2.865,2.865,0,0,0,2.941,2.381,4.279,4.279,0,0,0,3.781-2.1l.14-.14a9.419,9.419,0,0,0,.98-1.541Z",
    transform: "translate(-1.7 0.88)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1195",
    d: "M25.087,30.549a4.764,4.764,0,0,0,.14,1.4,2.923,2.923,0,0,0,1.541,2.241,7.457,7.457,0,0,0,4.2.98H37.83a6.961,6.961,0,0,0,6.3-3.362,9.305,9.305,0,0,0,1.26-3.781L47.21,19.2H40.492l-.7,3.081h.7l-1.121,5.461v.14c-.28.84-.98,1.26-2.241,1.26H32.369a1.18,1.18,0,0,1-.98-.98v-.14L34.33,14.443a1.507,1.507,0,0,1,1.4-1.12H46.794L48.054,7.3H36.711a8.728,8.728,0,0,0-5.6,1.541,9.655,9.655,0,0,0-2.661,5.322s-3.081,14.706-3.221,15.266a3.48,3.48,0,0,0-.142,1.12Z",
    transform: "translate(7.683 0.961)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1451",
    d: "M1.1,14.4",
    transform: "translate(-1.1 3.806)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Approve",
    d: "M10.2.264c6.1,0,8.943-3.036,8.943-6.567,0-8.481-13.992-4.95-13.992-10.593,0-2.013,1.683-3.663,5.61-3.663a11.93,11.93,0,0,1,6.336,1.881l1.089-2.64a13.59,13.59,0,0,0-7.425-2.046c-6.072,0-8.844,3.036-8.844,6.6,0,8.58,13.992,5.016,13.992,10.659,0,2.013-1.716,3.564-5.709,3.564A11.889,11.889,0,0,1,2.574-5.214L1.353-2.64C3.2-.924,6.666.264,10.2.264ZM32.505-17.655a7.584,7.584,0,0,0-6.171,2.64v-9.471H23.166V0h3.168V-9.009c0-3.8,2.178-5.808,5.544-5.808,3,0,4.719,1.683,4.719,5.115V0h3.168V-10.065C39.765-15.213,36.762-17.655,32.505-17.655ZM52.9.2a8.7,8.7,0,0,0,9.075-8.943,8.676,8.676,0,0,0-9.075-8.91c-5.247,0-9.108,3.7-9.108,8.91A8.729,8.729,0,0,0,52.9.2Zm0-2.772a5.791,5.791,0,0,1-5.907-6.171A5.764,5.764,0,0,1,52.9-14.883c3.366,0,5.874,2.409,5.874,6.138S56.265-2.574,52.9-2.574ZM75.306-17.655a7.449,7.449,0,0,0-6.237,2.937V-17.49H66.033V6.4H69.2V-2.64A7.469,7.469,0,0,0,75.306.2,8.5,8.5,0,0,0,84.15-8.745,8.489,8.489,0,0,0,75.306-17.655ZM75.042-2.574c-3.333,0-5.874-2.442-5.874-6.171a5.775,5.775,0,0,1,5.874-6.138,5.782,5.782,0,0,1,5.907,6.138A5.791,5.791,0,0,1,75.042-2.574Zm32.5,2.838a11.462,11.462,0,0,0,8.811-3.63l-2.145-2.079a8.59,8.59,0,0,1-6.5,2.772,8.725,8.725,0,0,1-9.075-8.877,8.725,8.725,0,0,1,9.075-8.877,8.559,8.559,0,0,1,6.5,2.739l2.145-2.079a11.415,11.415,0,0,0-8.778-3.6c-7.029,0-12.243,4.983-12.243,11.814S100.551.264,107.547.264ZM127.05.2a8.7,8.7,0,0,0,9.075-8.943,8.676,8.676,0,0,0-9.075-8.91c-5.247,0-9.108,3.7-9.108,8.91A8.729,8.729,0,0,0,127.05.2Zm0-2.772a5.791,5.791,0,0,1-5.907-6.171,5.764,5.764,0,0,1,5.907-6.138c3.366,0,5.874,2.409,5.874,6.138S130.416-2.574,127.05-2.574Zm22.473-15.081a7.5,7.5,0,0,0-6.3,2.805v-2.64h-3.036V0h3.168V-9.009c0-3.8,2.178-5.808,5.544-5.808,3,0,4.719,1.683,4.719,5.115V0h3.168V-10.065C156.783-15.213,153.78-17.655,149.523-17.655Zm22.143,0a7.5,7.5,0,0,0-6.3,2.805v-2.64h-3.036V0H165.5V-9.009c0-3.8,2.178-5.808,5.544-5.808,3,0,4.719,1.683,4.719,5.115V0h3.168V-10.065C178.926-15.213,175.923-17.655,171.666-17.655Zm28.71,9.009c0-5.379-3.6-9.009-8.646-9.009a8.566,8.566,0,0,0-8.778,8.91c0,5.214,3.762,8.943,9.4,8.943a8.779,8.779,0,0,0,6.9-2.838l-1.749-2.046a6.53,6.53,0,0,1-5.049,2.112c-3.465,0-5.94-2.046-6.336-5.115h14.19C200.343-7.986,200.376-8.382,200.376-8.646Zm-8.646-6.336a5.454,5.454,0,0,1,5.61,5.016H186.12A5.452,5.452,0,0,1,191.73-14.982ZM212.058.2a7.825,7.825,0,0,0,7.128-3.762l-2.409-1.518a5.452,5.452,0,0,1-4.752,2.508,5.8,5.8,0,0,1-6.006-6.171,5.8,5.8,0,0,1,6.006-6.138,5.452,5.452,0,0,1,4.752,2.508l2.409-1.551a7.8,7.8,0,0,0-7.128-3.729c-5.379,0-9.24,3.7-9.24,8.91S206.679.2,212.058.2Zm19.965-3.5a3.99,3.99,0,0,1-2.475.825c-1.749,0-2.739-1.056-2.739-2.937v-9.471h5.016V-17.49h-5.016v-3.828h-3.168v3.828h-2.97v2.607h2.97v9.6c0,3.531,2.013,5.478,5.544,5.478a5.976,5.976,0,0,0,3.828-1.221Z",
    transform: "translate(89.66 33)",
    fill: "#fff",
    opacity: 0.796
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppshop);
export default __webpack_public_path__ + "static/media/appshop.373a6b1344736dacd1da3bc81adf6302.svg";
export { ForwardRef as ReactComponent };